import React, { useState } from "react";
import Dialog from "../Dialog";
import Button from "../Button";

const AcceptMentorshipDialog = ({ 
  isOpen, 
  onClose, 
  onAccept,
  title = "Accept Mentorship",
  description = "Write a reason for accepting this idea.",
  buttonLabel = "Accept Idea",
  reasonLabel = "Reason for acceptance"
}) => {
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");

  const handleClose = () => {
    setReason("");
    setError("");
    onClose();
  };

  const handleAccept = () => {
    if (!reason.trim()) {
      setError(`${reasonLabel} is required`);
      return;
    }

    if (onAccept) {
      onAccept(reason);
    }
    handleClose();
  };

  return (
    <Dialog
      isOpen={isOpen}
      onClose={handleClose}
      title={title}
      description={description}
    >
      <div className="flex flex-col gap-4">
        <div>
          <label className="text-sm font-medium text-slate-700 block mb-2">
            {reasonLabel} <span className="text-red-500">*</span>
          </label>
          <textarea
            value={reason}
            onChange={(e) => {
              setReason(e.target.value);
              if (error) setError("");
            }}
            placeholder="Write your reason here..."
            rows={6}
            className={`w-full rounded-lg border ${
              error ? "border-red-400" : "border-slate-200"
            } bg-white px-4 py-3 text-sm text-slate-900 shadow-sm focus:border-brand-blue focus:outline-none focus:ring-2 focus:ring-brand-blue resize-none`}
          />
          {error && (
            <p className="text-xs text-red-500 mt-1">{error}</p>
          )}
        </div>

        {/* Action Buttons */}
        <div className="flex items-center justify-end gap-3 pt-4">
          <Button
            variant="secondary"
            size="medium"
            onClick={handleClose}
            className="bg-white border-slate-200 text-slate-700 hover:bg-slate-50"
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            size="medium"
            onClick={handleAccept}
            className="bg-purple-600 hover:bg-purple-700 text-white"
          >
            {buttonLabel}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default AcceptMentorshipDialog;

